import { render, staticRenderFns } from "./ConfirmOrder.vue?vue&type=template&id=781aa985&scoped=true&"
import script from "./ConfirmOrder.vue?vue&type=script&lang=ts&"
export * from "./ConfirmOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmOrder.vue?vue&type=style&index=0&id=781aa985&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781aa985",
  null
  
)

export default component.exports